module.exports = __webpack_public_path__ + "img/logo.eb359f32.svg";